import { createSelector } from '@reduxjs/toolkit';
import { ProjectId, TaskId } from 'api/models';
import { FetchStatus } from 'data/core';
import { Task } from 'data/tasks';
import { RootState } from '../index';

export const selectTask =
  ([, , taskId]: TaskId) =>
  ({ tasks }: RootState): Task => {
    return tasks.items[taskId];
  };

export const selectTaskFetchStatus =
  (_taskId: number) =>
  ({ tasks }: RootState): FetchStatus => {
    return tasks.itemsFetchStatus[_taskId];
  };

export const selectTasksByProjectIdSelector = () =>
  createSelector(
    [(state: RootState) => state.tasks, (_, taskIds: number[]) => taskIds],
    (tasks, taskIds): Task[] => {
      return (taskIds || [])
        .map((id): Task => {
          return tasks.items[id];
        })
        .filter(Boolean);
    },
  );

export const selectTasksByProjectId =
  ([, projectId]: ProjectId) =>
  ({ tasks }: RootState): Task[] =>
    Object.values(tasks.items).filter((t) => t.project === projectId);

export const selectAllTasks = ({ tasks }: RootState): Task[] =>
  Object.values(tasks.items);

export const getTasksByProjectId = () =>
  createSelector(
    [(state: RootState) => state.tasks, (_, projectId: number) => projectId],
    (tasks, projectId): Task[] => {
      return Object.values(tasks.items).filter((t) => t.project === projectId);
    },
  );

export const selectLastBoardTaskSaved = ({
  tasks,
}: RootState): { taskId: number; projectId: number } | null =>
  tasks.lastBoardTaskSaved ?? null;
